import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { noTranslationMock } from '../../translations/lobby-missing-translation.handler';

@Pipe({
    name: 'hasTranslation',
    standalone: false
})
export class HasTranslationPipe implements PipeTransform {

  constructor(private readonly translateService: TranslateService) {
  }

  transform(value: string): boolean {
    const translation = this.translateService.instant(value)
    return translation !== value && translation !== '' && translation !== noTranslationMock
  }

}
